/**
 * Custom element that resolves the matching variant for a "Complete the Look"
 * card as the shopper changes its options (colour swatches, size buttons,
 * or plain dropdowns for anything else), and keeps the hidden variant id
 * input + Quick Add button in sync so the form can add the currently
 * selected variant to the cart.
 */
class CompleteLookPicker extends HTMLElement {
  connectedCallback() {
    this.optionGroups = Array.from(this.querySelectorAll('[data-option-index]'));
    this.variantIdInput = this.querySelector('input[name="id"]');
    this.addToCartButton = this.querySelector('[ref="addToCartButton"]');

    const variantsScript = this.querySelector('script[data-variants]');
    this.variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];

    this.selectedOptions = [];

    this.optionGroups.forEach((group) => {
      const index = Number(group.dataset.optionIndex);

      if (group.tagName === 'SELECT') {
        this.selectedOptions[index] = group.value;
        group.addEventListener('change', () => {
          this.selectedOptions[index] = group.value;
          this.#updateVariant();
        });
        return;
      }

      const buttons = Array.from(group.querySelectorAll('button'));
      const selectedButton = group.querySelector('.is-selected') || buttons[0];
      this.selectedOptions[index] = selectedButton?.dataset.value;

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          buttons.forEach((otherButton) => otherButton.classList.remove('is-selected'));
          button.classList.add('is-selected');
          this.selectedOptions[index] = button.dataset.value;
          this.#updateVariant();
        });
      });
    });
  }

  #updateVariant() {
    const matchedVariant = this.variants.find((variant) =>
      variant.options.every((option, index) => option === this.selectedOptions[index])
    );

    if (!this.variantIdInput || !this.addToCartButton) return;

    if (matchedVariant) {
      this.variantIdInput.value = matchedVariant.id;
      this.addToCartButton.disabled = !matchedVariant.available;
    } else {
      this.addToCartButton.disabled = true;
    }
  }
}

if (!customElements.get('complete-look-picker')) {
  customElements.define('complete-look-picker', CompleteLookPicker);
}
